import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { FlowsService } from '../../../flows.service';

@Component({
  selector: 'app-cancel-test-ab',
  templateUrl: './cancel-test-ab.component.html',
  styleUrl: './cancel-test-ab.component.scss'
})
export class CancelTestAbComponent implements OnInit {

  model: {
    open: boolean;
    partner: string;
    account: string;
    flow_version: any;
    selector_test: any;
    snapshot_id: string;
  } = {
      open: true,
      partner: '',
      account: '',
      flow_version: null,
      selector_test: null,
      snapshot_id: ''
    };

  isSelected = false;
  selectedOption: number | null = 1;

  constructor(
    private router: Router,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<CancelTestAbComponent>,
    private flowService: FlowsService
  ) { }

  ngOnInit(): void {
    if (this.data) {
      this.model.partner = this.data.partner ?? '';
      this.model.account = this.data.account ?? '';
      this.model.flow_version = this.data.flow_version ?? null;
      this.model.selector_test = this.data.selector_test ?? null;
      this.model.snapshot_id = this.data.snapshot_id ?? '';
    }
  }

  close(): void {
    this.dialogRef.close({ isBack: false });
  }

  seeFlows(): void {
    this.dialogRef.close({ isBack: true });
    this.router.navigate([this.model.partner, this.model.account, 'snapshot']);
  }

  setOnlyOne(option: number): void {
    this.selectedOption = this.selectedOption === option ? null : option;
  }

  publish(): void {
    this.dialogRef.close({ isBack: true });
    this.router.navigate([this.model.partner, this.model.account, 'snapshot', 'publish']);
  }

  // Teste
  cancelTestAb() {

    var params = {
      snapshot_id: this.model.snapshot_id,
      selector_test_id: this.model.selector_test.id,
      flow_id: this.model.selector_test.selector_test_flows[this.selectedOption].flow_id,
      version: this.model.selector_test.selector_test_flows[this.selectedOption].version,
    };

    this.isSelected = true;

    this.flowService.finishTestAB(this.model.partner, this.model.account, params)
      .subscribe(
        {
          next: (response) => {
            this.isSelected = true;

          },
          error: (error) => {
          }
        });
  }

  changeVersion() {
  }
}
